import { SvgIcon, SvgIconProps } from '@mui/material';

export function FolderIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 500 500'
    >
      <g filter='url(#filter0_i_511_57)'>
        <rect
          width='500'
          height='500'
          rx='250'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_511_57)'>
          <path
            d='M137.18 147.811V200.659L362.583 201.383V175.562C362.374 171.461 360.838 170.329 356.321 169.771H228.449L195.939 142.744H143.923C138.395 142.684 137.619 144.288 137.18 147.811Z'
            fill='#1F477D'
          />
          <path
            d='M137.18 147.811V200.659L362.583 201.383V175.562C362.374 171.461 360.838 170.329 356.321 169.771H228.449L195.939 142.744H143.923C138.395 142.684 137.619 144.288 137.18 147.811Z'
            stroke='#1F477D'
            fill='none'
          />
        </g>
        <g filter='url(#filter2_d_511_57)'>
          <path
            d='M126.586 209.42C126.867 202.934 129.353 201.618 135.737 201.215H362.103C369.81 200.7 372.05 202.787 373.421 209.42L365.234 347.933C365.101 355.131 362.783 357.047 355.601 357.585H142.721C136.293 357.408 133.905 355.797 133.57 347.933L126.586 209.42Z'
            fill='#3E8FFA'
          />
          <path
            d='M126.586 209.42C126.867 202.934 129.353 201.618 135.737 201.215H362.103C369.81 200.7 372.05 202.787 373.421 209.42L365.234 347.933C365.101 355.131 362.783 357.047 355.601 357.585H142.721C136.293 357.408 133.905 355.797 133.57 347.933L126.586 209.42Z'
            stroke='#3E8FFA'
            fill='none'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_i_511_57'
          x='0'
          y='0'
          width='509'
          height='520'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_511_57'
          />
        </filter>
        <filter
          id='filter1_d_511_57'
          x='134.68'
          y='142.242'
          width='240.403'
          height='76.642'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_57'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_57'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_511_57'
          x='124.085'
          y='200.64'
          width='261.839'
          height='174.445'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_57'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_57'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
